export const API_ENDPOINT = 'https://appserver.globalease.fr';